<template>
  <base-modal
      icon="get_app"
      title="Export Note">
    <h3>Format</h3>
    <div class="select-container select-container-format">
      <div
          v-for="format of formats"
          :key="format.key"
          class="option option-format">
        <input
            :id="`format-${format.key}`"
            v-model="selectedFormat"
            :value="format.key"
            type="radio"
            name="format">
        <label :for="`format-${format.key}`">
          <component
              :is="format.icon"
              class="option-icon option-format-icon"/>
          <span>
            {{ format.name }}
          </span>
        </label>
      </div>
    </div>
    <h3 v-show="selectedFormat === 'html'">Theme</h3>
    <div
        v-show="selectedFormat === 'html'"
        class="select-container select-container-theme">
      <template v-for="theme of themes">
        <input
            :id="`theme-${theme.key}`"
            :key="`${theme.key}-input`"
            v-model="selectedTheme"
            :value="theme.key"
            type="radio"
            name="theme">
        <label
            :key="`${theme.key}-label`"
            :for="`theme-${theme.key}`"
            :title="theme.name"
            class="option option-theme">
          <component
              :is="theme.icon"
              class="option-icon option-theme-icon"/>
          <span>
            {{ theme.name }}
          </span>
        </label>
      </template>
    </div>
    <template #footer>
      <base-button
          text="Cancel"
          @click="$modal.dismiss"/>
      <base-button
          text="Export"
          @click="exportNote"/>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import BaseModal from '@/components/core/modal/BaseModal.vue';

import HTMLFormatIcon from '@/assets/formats/html.svg';
import MarkdownFormatIcon from '@/assets/formats/markdown.svg';

import DarkThemeIcon from '@/assets/themes/dark.svg';
import LightThemeIcon from '@/assets/themes/light.svg';
import SkyThemeIcon from '@/assets/themes/sky.svg';

export default {
  name: 'ExportModal',
  components: {
    BaseButton,
    BaseModal,
  },
  props: {
    note: Object,
  },
  data() {
    return {
      selectedFormat: 'md',
      selectedTheme: 'dark',
      formats: [
        {
          key: 'md',
          name: 'Markdown',
          icon: MarkdownFormatIcon,
        },
        {
          key: 'html',
          name: 'HTML',
          icon: HTMLFormatIcon,
        },
      ],
      themes: [
        {
          key: 'dark',
          name: 'Litera Dark',
          icon: DarkThemeIcon,
        },
        {
          key: 'light',
          name: 'Litera Light',
          icon: LightThemeIcon,
        },
        {
          key: 'sky',
          name: 'Sky',
          icon: SkyThemeIcon,
        },
      ],
    };
  },
  methods: {
    async exportNote() {
      let formatOptions;

      if (this.selectedFormat === 'html') {
        formatOptions = {
          theme: this.selectedTheme,
        };
      }

      await this.$store.dispatch('notes/exportCurrentNote', {
        format: this.selectedFormat,
        formatOptions,
      });

      this.$modal.dismiss();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

h3 {
  font-weight: normal;
  padding: 0 0.75rem;
}

.select-container {
  display: flex;
  justify-content: center;
  padding: 1rem;

  input {
    display: none;
  }

  label {
    align-items: center;
    background: $background;
    border-radius: 0.5rem;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    margin: 0.5rem;
    transition: background .2s;
    justify-content: space-between;

    .option-icon {
      flex-grow: 1;
      margin: 0.75rem;
    }

    span {
      margin: 0 0.5rem 0.5rem;
      text-align: center;
      flex-grow: 1;
    }
  }

  input:checked + label {
    background: $primary;
  }

  &-format {
    label {
      width: 8rem;
    }
  }

  &-theme {
    label {
      width: 5.5rem;
    }
  }
}
</style>
